import { JsToClientCommand } from '../jsToClientCommand';
import { ClientCommands } from '../clientCommands';

export class SetClientNewNotificationsStateHandler extends JsToClientCommand<{}> {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    constructor(params: {[key:string]: any}) {
        super(ClientCommands.SET_CLIENT_NEW_NOTIFICATIONS_STATE, params);
    }
}
